import React from "react"
import { Container, Alert } from "reactstrap"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Trans, useLingui } from "@lingui/react"

import { setCurrentPage } from "../../store/reducers/navigation"
import Transaction from "./ActiveMeetingTransactions/Transaction"
import { fullArabicDateConverter } from "../../view/shared/utilities/arabicDateConverter"
import { deleteCacheByKey } from "../../view/shared/utilities/cache"

const dateStyle = {
  color: "#E36F1E",
  fontFamily: "quicksand",
  fontWeight: "bolder",
  fontSize: "25px",
  padding: ".5rem",
  textAlign: "center",
  margin: "34px 0 0 0",
}

const OfflineMeetingTransactions = (props) => {
  const { i18n } = useLingui()

  const removeTransaction = async (id) => {
    await deleteCacheByKey("offlineRequests", "cacheId", id)
  }

  if (!props.offlineTransactions.length) {
    return (
      <div>
        <div style={dateStyle}>
          <span>
            {!["ar"].includes(i18n.locale) &&
              new Date(
                props.offlineMeeting.date,
                // update the translation to use helper's module function
              ).toLocaleString(i18n.language, {
                dateStyle: "full",
              })}
            {["ar"].includes(i18n.locale) &&
              fullArabicDateConverter(props.offlineMeeting.date)}
          </span>
        </div>
        <br />
        <Container>
          <Alert color="warning">
            <span style={{ fontSize: "16px", fontFamily: "Fira Sans" }}>
              <Trans id="no.transactions">No transactions</Trans>
            </span>
          </Alert>
        </Container>
      </div>
    )
  }

  return (
    <div>
      {props.offlineMeeting && (
        <>
          <div style={dateStyle}>
            <span>
              {!["ar"].includes(i18n.locale) &&
                new Date(props.offlineMeeting.date).toLocaleString(
                  // update the translation to use helper's module function
                  i18n.language,
                  { dateStyle: "full" },
                )}
              {["ar"].includes(i18n.locale) &&
                fullArabicDateConverter(props.offlineMeeting.date)}
            </span>
          </div>
          <br />
          {props.offlineMeeting.error && (
            <span
              style={{ color: "red", display: "flex", justifyContent: "center" }}
            >
              {props.offlineMeeting.error}
            </span>
          )}
          <Container style={{ paddingBottom: "30px" }}>
            {props.offlineTransactions.map((item) => (
              <>
                <Transaction
                  data={item}
                  key={item.requestId}
                  customAction={removeTransaction}
                  customBtnLabel="Remove"
                />
                <hr />
              </>
            ))}
          </Container>
        </>
      )}
    </div>
  )
}

OfflineMeetingTransactions.propTypes = {
  vsla: PropTypes.object,
  offlineTransactions: PropTypes.array,
  offlineMeeting: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    vsla: state.vsla,
    offlineMeeting: state.meeting?.ongoing,
    offlineTransactions: state.meetingTransactions.filter(tx => tx.isOffline).map(tx => ({
      ...tx,
      transactionType: tx.type
    }))
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: (page) => dispatch(setCurrentPage(page)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OfflineMeetingTransactions)
